import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/business";

export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${BUSINESS.phoneClean}`}
      data-testid="sticky-call-button"
      aria-label={`Call Blossom Spa Madhapur at ${BUSINESS.phone}`}
      className="fixed z-[60] bottom-5 right-5 sm:bottom-7 sm:right-7 flex items-center gap-2.5 bg-spa-slate text-spa-cream pl-4 pr-5 py-3.5 sm:py-4 rounded-full shadow-[0_12px_32px_-8px_rgba(44,58,51,0.45)] border border-spa-sage/30 hover:bg-spa-slateHover hover:scale-105 active:scale-95 transition-all duration-300"
    >
      <span className="relative flex items-center justify-center w-6 h-6">
        <span className="absolute inline-flex h-full w-full rounded-full bg-spa-sage/50 animate-ping" />
        <Phone className="relative w-4 h-4" strokeWidth={2} />
      </span>
      <span className="font-sans text-sm sm:text-[15px] font-medium tracking-wide whitespace-nowrap">
        {BUSINESS.phoneDisplay}
      </span>
    </a>
  );
};
